import React, { useRef } from 'react';
import { extend } from '@react-three/fiber';
import { a } from '@react-spring/three';
import * as meshline from 'threejs-meshline';
import { useMeteors, useMeteor } from './use-meteors';
extend(meshline);
const Meteor = ({ value, style }) => {
    const meteor = useRef();
    const mat = useRef();
    useMeteor(meteor, mat, { value });
    return (React.createElement(a.mesh, { ref: meteor, "material-opacity": style === null || style === void 0 ? void 0 : style.opacity.to((x) => x * 0.75) },
        React.createElement("meshLine", { attach: "geometry", vertices: value.vertices }),
        React.createElement("meshLineMaterial", { attach: "material", ref: mat, transparent: true, depthTest: false, sizeAttenuation: true, lineWidth: 0.02, dashArray: 0.5, dashRatio: 0.7, color: value.color })));
};
const Meteors = (props) => {
    const { meteors } = useMeteors(props);
    return (React.createElement(React.Fragment, null, meteors.map((meteor, index) => {
        return React.createElement(Meteor, { key: index, value: meteor, style: props.style });
    })));
};
export default Meteors;
